import { FormEvent } from 'react';
import { Link } from 'react-router-dom';

import TokenFieldBlock from '../../Blocks/TokenFieldBlock';
import {
    BusyDisplay,
    ErrorDisplay,
    FormDisplay,
    StyleTokenSection,
    Title,
} from './TokenSection.styled';

/* ---------------------------------- Types --------------------------------- */

export interface DumbTokenSectionI {
    /** Handler to call after the pairing code has been entered */
    handleChange: (index: number) => (character: string) => void;

    /** Handler when a pairing code has been pasted */
    handlePaste: () => void;

    /** Strings telling the user what is going on */
    labels: {
        pairingTitleText: string;
        pairingBusyText: string;
        pairingExitText: string;
    };

    /** Variable that contains an error when there is one */
    error?: string;

    /** The index of the currently active field  */
    currentIndex: number;

    /** Variable that holds the token the user types in */
    token: string[];

    /** Method for moving to the previous input field */
    moveToPrevious: (index: number) => void;

    /** Variable holding the state of the form */
    isBusy: boolean;

    /** URL of the brand logo returned by the ThemeAPI */
    logo: JSX.Element | null;

    showExitButton?: boolean;
}

/* -------------------------------- Component ------------------------------- */

/**
 * DumbTokenSection
 *
 * @param props DumbTokenSectionI..arg
 * @returns JSX.Element
 */
const DumbTokenSection = ({
    handleChange,
    handlePaste,
    labels,
    error,
    currentIndex,
    token,
    moveToPrevious,
    isBusy,
    logo,
    showExitButton = false,
}: DumbTokenSectionI) => {
    const { pairingBusyText, pairingTitleText, pairingExitText } = labels;

    // prevent default form behaviour
    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    };

    return (
        <StyleTokenSection>
            {showExitButton ? (
                <Link to="/">
                    <i className="fa fa-chevron-left" /> {pairingExitText}
                </Link>
            ) : null}
            <FormDisplay>
                {logo}
                <Title>{pairingTitleText}</Title>
                <form onSubmit={handleSubmit} onPaste={handlePaste}>
                    {token.map((val, index: number) => (
                        <TokenFieldBlock
                            // eslint-disable-next-line react/no-array-index-key
                            key={`${val}-${index}`}
                            value={token[index]}
                            isActive={currentIndex === index}
                            handleChange={handleChange(index)}
                            moveToPrevious={() => {
                                moveToPrevious(index);
                            }}
                        />
                    ))}
                </form>
                {error && <ErrorDisplay>{error}</ErrorDisplay>}
                {isBusy && <BusyDisplay>{pairingBusyText}</BusyDisplay>}
            </FormDisplay>
        </StyleTokenSection>
    );
};

/* --------------------------------- Export --------------------------------- */

export default DumbTokenSection;
